import "../../Public/css/messenger.css";
// import Topbar from "../../components/topbar/Topbar";
import Conversation from "../Conversations/Conversations";
import Message from "../Message/Message";
import ChatOnline from "../chatOnline/ChatOnline";
import { useContext, useEffect, useRef, useState } from "react";
// import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { io } from "socket.io-client";
import useGetUser from "../../Hooks/useGetUser";

export default function Messenger(props) {
  const [conversations, setConversations]=useState([]);
  const [currentChat, setCurrentChat]=useState(null);
  const [messages, setMessages]=useState([]);
  const [newMessage, setNewMessage]=useState("");
  const [arrivalMessage, setArrivalMessage]=useState(null);
  const [onlineUsers, setOnlineUsers]=useState([]);
  const socket=useRef();
  const [user]=useGetUser({});
  const scrollRef=useRef();
  // console.log(user)
  useEffect(() => {
    socket.current=io("ws://localhost:5000");
    socket.current.on("getMessage", (data) => {
      setArrivalMessage({
        sender: data.senderId,
        text: data.text,
        createdAt: Date.now(),
      });
    });
  }, []);

  useEffect(() => {
    arrivalMessage&&
      currentChat?.members.includes(arrivalMessage.sender)&&
      setMessages((prev) => [...prev, arrivalMessage]);
  }, [arrivalMessage, currentChat]);

  useEffect(() => {
    socket.current.emit("addUser", user._id);
    socket.current.on("getUsers", (users) => {
      setOnlineUsers(users);
      console.log(users);
    });
  }, [user]);

  useEffect(() => {
    const getConversations=async () => {
      try {
        const res=await axios.get("https://bit-dev22.herokuapp.com/api/conversations/"+user._id);
        setConversations(res.data.conversation);
      } catch (err) {
        console.log(err);
      }
    };
    getConversations();
  }, [user._id]);

  useEffect(() => {
    const getMessages=async () => {
      try {
        const res=await axios.get("https://bit-dev22.herokuapp.com/api/messages/"+currentChat?._id);
        setMessages(res.data);
        // console.log(res);
      } catch (err) {
        console.log(err);
      }
    };
    getMessages();
  }, [currentChat]);

  const handleSubmit=async (e) => {
    e.preventDefault();
    const message={
      sender: user._id,
      text: newMessage,
      conversationId: currentChat._id,
    };

    const receiverId=currentChat.members.find(
      (member) => member!==user._id
    );

    socket.current.emit("sendMessage", {
      senderId: user._id,
      receiverId,
      text: newMessage,
    });

    try {
      const res=await axios.post("https://bit-dev22.herokuapp.com/api/messages", message);
      setMessages([...messages, res.data]);
      setNewMessage("");
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  console.log(currentChat);
  console.log(messages);
  return (
    <>
      <div className="messenger">
        <div className="chatMenu">
          <div className="chatMenuWrapper">
            <input placeholder="Search for friends" className="chatMenuInput" />
            {conversations.map((c) => (
              <div onClick={() => setCurrentChat(c)}>
                <Conversation conversation={c} currentUser={user} />
              </div>
            ))}
          </div>
        </div>
        <div className="chatBox">
          <div className="chatBoxWrapper">
            {currentChat? (
              <>
                <div className="chatBoxTop">
                  {messages.map((m) => (
                    <div ref={scrollRef}>
                      <Message message={m} own={m.sender===user._id} />
                    </div>
                  ))}
                </div>
                <div className="chatBoxBottom">
                  <textarea
                    className="chatMessageInput"
                    placeholder="write something..."
                    onChange={(e) => setNewMessage(e.target.value)}
                    value={newMessage}
                  ></textarea>
                  <button className="chatSubmitButton" onClick={handleSubmit}>
                    Send
                  </button>
                </div>
              </>
            ):(
              <span className="noConversationText">
                Open a conversation to start a chat.
              </span>
            )}
          </div>
        </div>
        <div className="chatOnline">
          <div className="chatOnlineWrapper">
            <ChatOnline
              onlineUsers={onlineUsers}
              currentId={user._id}
              setCurrentChat={setCurrentChat}
            />
          </div>
        </div>
      </div>
    </>
  );
}